import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { t } from '../utils/translations';
import './ThemeToggle.css';

const ThemeToggle = ({ language = 'en' }) => {
  const { isDarkMode, toggleTheme } = useTheme();

  return (
    <button
      className="theme-toggle"
      onClick={toggleTheme}
      aria-label={isDarkMode ? t('switchToLightMode', language) : t('switchToDarkMode', language)}
      title={isDarkMode ? t('switchToLightMode', language) : t('switchToDarkMode', language)}
    >
      {isDarkMode ? '☀️' : '🌙'}
    </button>
  );
};

export default ThemeToggle;

